var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeIcon = function SvgEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.685.834c6.977-.21 11.083 6.288 11.83 7.583a1.17 1.17 0 0 1 0 1.167c-1.003 1.75-4.748 7.42-11.2 7.583h-.292c-6.871 0-10.803-6.312-11.538-7.583a1.17 1.17 0 0 1 0-1.167C1.5 6.667 5.233.997 11.685.834M9.73 12.396a4.084 4.084 0 1 0 4.538-6.792 4.084 4.084 0 0 0-4.538 6.792M13.75 9a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgEyeIcon;